<template>
    <Card
        padding="0"
        custom-classes="tw:overflow-hidden tw:border-gray-100"
        bg-color="tw:bg-blue-700"
        title="Datos del deportista"
        title-color="white"
        icon="fas fa-running tw:opacity-80"
    >

        <div class="tw:p-6">
            <!-- Sección 1: Datos del menor -->
            <div class="tw:space-y-3">
                <p class="tw:text-xs tw:font-semibold tw:text-gray-400 tw:uppercase tw:tracking-wider tw:flex tw:items-center tw:gap-1">
                    <i class="fas fa-child"></i> Datos del menor
                </p>
                <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-3 tw:gap-4">
                    <DataField icon="fas fa-user" label="Nombre" :value="base.nombre" />
                    <DataField icon="fas fa-user" label="Apellidos" :value="base.apellidos" />
                    <DataField icon="fas fa-id-badge" label="DNI" :value="base.dni" />
                    <DataField icon="fas fa-calendar-alt" label="Fecha de nacimiento" :value="base.fecha_de_nacimiento" />
                    <DataField icon="fas fa-calendar-check" label="Fecha caducidad DNI" :value="base.fecha_de_caducidad_dni" />
                    <DataField icon="fas fa-phone-alt" label="Teléfono" :value="base.telefono" />
                    <DataField icon="fas fa-envelope" label="Email" :value="base.email" />
                    <DataField icon="fas fa-globe-americas" label="País de nacimiento" :value="base.pais_de_nacimiento" />
                    <DataField icon="fas fa-map-marker-alt" label="Localidad de nacimiento" :value="base.localidad_de_nacimiento" />
                    <DataField icon="fas fa-map-pin" label="Provincia de nacimiento" :value="base.provincia_de_nacimiento" />
                    <DataField icon="fas fa-flag" label="Nacionalidad" :value="base.nacionalidad" />
                    <DataField icon="fas fa-home" label="Dirección" :value="base.direccion" />
                    <DataField icon="fas fa-shield-alt" label="Club de procedencia" :value="base.club_de_procedencia" />
                    <DataField icon="fas fa-hand-paper" label="Lateralidad" :value="base.lateralidad" />
                    <DataField icon="fas fa-layer-group" label="Categoría" :value="base.categoria" />
                    <!-- Campos personalizados del deportista -->
                    <DataField
                        v-for="field in base.fields_deportista"
                        :key="field.name"
                        icon="fas fa-tag"
                        :label="humanizeFieldName(field.name)"
                        :value="field.value"
                    />
                </div>
            </div>

            <!-- Sección 2: Datos del equipo (solo si existe) -->
            <template v-if="base.equipo">
                <div class="tw:border-t tw:border-gray-100 tw:my-3"></div>
                <div class="tw:space-y-3">
                    <p class="tw:text-xs tw:font-semibold tw:text-gray-400 tw:uppercase tw:tracking-wider tw:flex tw:items-center tw:gap-1">
                        <i class="fas fa-users"></i> Datos del equipo
                    </p>
                    <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-3 tw:gap-4">
                        <DataField icon="fas fa-users" label="Nombre" :value="base.equipo.nombre" />
                        <DataField icon="fas fa-chart-bar" label="Edad Media" :value="equipoEdadMedia" />
                        <DataField icon="fas fa-user-tie" label="Entrenador" :value="equipoEntrenador" />
                    </div>
                </div>
            </template>
        </div>
    </Card>
</template>

<script setup>
    import { computed } from 'vue'
    import Card from '@/modules/admin/ui/Card.vue'
    import DataField from '@/modules/admin/ui/DataField.vue'
    import { humanizeFieldName } from '@/utils/format'

    const props = defineProps({
        base: {
            type: Object,
            required: true
        },
        manager: {
            type: Object,
            default: () => ({})
        }
    })

    const equipoEdadMedia = computed(() => {
        if (!props.base?.equipo?.edad_media) return '-'
        return props.base.equipo.edad_media + ' años'
    })

    const equipoEntrenador = computed(() => {
        return props.base?.equipo?.representante?.name || '-'
    })
</script>
